/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useEffect, useState, Fragment } from 'react';
import { isEmpty } from 'lodash';
// eslint-disable-next-line import/no-unresolved
import moment from 'moment';
import parse from 'html-react-parser';
import CustomSlider from '../../CustomSlider';

import domContentParser from '../../../utils/domContentParser';
import './index.scss';

const DadaDarlings = (props) => {
  const { data, icon, redirectToBlog } = props;
  const [slide, setSlide] = useState({});
  const [blogIndex, setBlogIndex] = useState(0);

  useEffect(() => {
    if (!isEmpty(data)) {
      const slideData = preparedSlideData(data, blogIndex);
      setSlide(slideData);
    }
  }, [data]);

  useEffect(() => {
    if (!isEmpty(data)) {
      const slideData = preparedSlideData(data, blogIndex);
      setSlide(slideData);
    }
  }, [blogIndex]);

  const preparedSlideData = (data, index) => {
    const currentSlide = data[index];
    const {
      id,
      title,
      thumbnail,
      author,
      published_at,
      content,
    } = currentSlide;
    const domTree = domContentParser(content);

    return {
      id,
      title,
      thumbnail,
      author,
      published_at,
      ...domTree,
    };
  };

  return (
    <Fragment>
      {!isEmpty(slide) && (
        <div className="dadaInActionContainer resp-wrap">
          <div className="dadaInActionImgWrap w-40">
            <div className="dadaEditorialImg">
              <div className="newsHeader">
                <div className="headingTag">DADAarlings</div>
              </div>
              <div onClick={() => redirectToBlog(slide.id)} role="button" tabIndex={0}>
                <img
                  src={slide.thumbnail}
                  className="blog-image"
                  alt="blog-one"
                />
              </div>
            </div>

            <div className="details-container">
              <div className="details">
                <div className="author pl-none">{slide.author}</div>
                <div className="published">
                  <span>published on:</span> &nbsp;
                  <strong>
                    {slide.published_at
                      ? moment(slide.published_at).format('LL')
                      : ''}
                  </strong>
                </div>
                <div className="pagination-container">
                  <CustomSlider
                    data={data}
                    setIndex={setBlogIndex}
                    index={blogIndex}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="dadaContent-container w-60">
            <div className="content-container">
              <div className="blog-title pl-mini" onClick={() => redirectToBlog(slide.id)} role="button">{parse(slide.title)}</div>
              <div className="description pl-mini">
                {slide.heading && (
                  <h3>
                    <strong>{parse(slide.heading)}</strong>
                  </h3>
                )}
                {slide.allContent && <p>{parse(slide.allContent)}</p>}
              </div>
              <div className="read  pl-mini">
                <span className="content" onClick={() => redirectToBlog(slide.id)} role="button" tabIndex={0}>read more </span>
                <span
                  className="open-link-icon"
                  onClick={() => redirectToBlog(slide.id)}
                  role="button"
                  tabIndex={0}
                >
                  <img src={icon} alt="open-link-icon" />
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default DadaDarlings;
